import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitProtectPlan`
//#region 基本信息
const GetList = (id: number) => `${apiUrl}/GetList/${id}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion
export const emptyProject: UnitBuiltProjectData = {
    Id: 0,
    ProtectPlanId: 0,
    DocId: 0,
    Specification: '',
    NewUserId: 0,
    NewDate: new Date(),
    DocNo: '',
    UserName: ''
}
export const emptyData: UnitProtectPlanData = {
    Id: 0,
    UnitId: 0,
    PlanLocationName: '',
    ProtectionArea: 0,
    ProtectionBoundary: '',
    MonitoringArea: 0,
    PlanMonitoringBoundary: '',
    PlanPhaseId: 0,
    ProtectionProjectName: '',
    PlanYear: 0,
    PlanMonth: 0,
    PlanDocId: 0,
    PlanNationFund: 0,
    PlanProvinceFund: 0,
    PlanPlaceFund: 0,
    IsGovernmentPublish: false,
    GovernmentPublishDocId: 0,
    PlanComplieUnit: '',
    ProtectionAreaAfter: 0,
    ProtectionBoundaryAfter: '',
    MonitoringAreaAfter: 0,
    MonitoringBoundaryAfter: '',
    OneLevelChecked: false,
    OneLevelHeight: 0,
    OneLevelPlotRatio: 0,
    OneLevelOther: '',
    TwoLevelChecked: false,
    TwoLevelHeight: 0,
    TwoLevelPlotRatio: 0,
    TwoLevelOther: '',
    ThreeLevelChecked: false,
    ThreeLevelHeight: 0,
    ThreeLevelPlotRatio: 0,
    ThreeLevelOther: '',
    ThreeLevelAboveChecked: false,
    ThreeLevelAbove: '',
    NoLevelChecked: false,
    OtherLevelChecked: false,
    OtherLevelName: '',
    HaveProject: false,
    MonitoringManageRule: '',
    ProtectionManageRule: '',
    Status: 0,

    PlanPhaseName: '',
    PlanDocNo: '',
    PublishDocNo: '',
    UserName: '',

    AttachTypeText: 0,
    AttachGuidText: '',
    AttachTypeDrawing: 0,
    AttachGuidDrawing: '',
    AttachTypeAssessment: 0,
    AttachGuidAssessment: '',
    AttachTypePicture: 0,
    AttachGuidPicture: ''
}
export interface UnitProtectPlanData {
    [key: string]: any
    Id: number
    UnitId: number
    PlanLocationName: string
    ProtectionArea: number
    ProtectionBoundary: string
    MonitoringArea: number
    PlanMonitoringBoundary: string
    PlanPhaseId: number
    ProtectionProjectName: string
    PlanYear: number
    PlanMonth: number
    PlanDocId: number
    PlanNationFund: number
    PlanProvinceFund: number
    PlanPlaceFund: number
    IsGovernmentPublish: boolean
    GovernmentPublishDocId: number
    PlanComplieUnit: string
    ProtectionAreaAfter: number
    ProtectionBoundaryAfter: string
    MonitoringAreaAfter: number
    MonitoringBoundaryAfter: string
    OneLevelChecked: boolean
    OneLevelHeight: number
    OneLevelPlotRatio: number
    OneLevelOther: string
    TwoLevelChecked: boolean
    TwoLevelHeight: number
    TwoLevelPlotRatio: number
    TwoLevelOther: string
    ThreeLevelChecked: boolean
    ThreeLevelHeight: number
    ThreeLevelPlotRatio: number
    ThreeLevelOther: string
    ThreeLevelAboveChecked: boolean
    ThreeLevelAbove: string
    NoLevelChecked: boolean
    OtherLevelChecked: boolean
    OtherLevelName: string
    HaveProject: boolean
    MonitoringManageRule: string
    ProtectionManageRule: string
    Status: number

    PlanPhaseName: string
    PlanDocNo: string
    PublishDocNo: string
    UserName: string

    AttachTypeText: number
    AttachGuidText: string
    AttachTypeDrawing: number
    AttachGuidDrawing: string
    AttachTypeAssessment: number
    AttachGuidAssessment: string
    AttachTypePicture: number
    AttachGuidPicture: string
}
export interface UnitBuiltProjectData {
    [key: string]: any
    Id: number
    ProtectPlanId: number
    DocId: number
    Specification: string
    NewUserId: number
    NewDate: Date
    DocNo: string
    UserName: string
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const getList = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetList(id),
    })
}
export const postData = (form: UnitProtectPlanData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitProtectPlanData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
